import flow from "lodash/fp/flow";
import find from "lodash/fp/find";
import map from "lodash/fp/map";
import reverse from "lodash/fp/reverse";
import moment from "moment";
import constants from "../../core/constants";
import { toObject, parsePrice } from "../../core/utils";

class InvoicePageTransform {
  constructor(Lists) {
    "ngInject";

    this.Lists = Lists.all;

    this.invoiceItemFields = [
      { name: "date", title: "Date" },
      { name: "amount", title: "Amount" },
      { name: "type", title: "Type" },
      { name: "active", title: "Active" },
      { name: "operator", title: "Operator" },
    ];
  }

  justify(data) {
    const fromatPlan = (plan) => {
      plan.rate /= constants.currencyBy;
      plan.extra_rate /= constants.currencyBy;
      plan.delay_deduction /= constants.currencyBy;
      plan.wage /= constants.currencyBy;

      return plan;
    };
    const formatDate = (item) => {
      item.start_date = moment(item.start_date).format(constants.dateFormat);
      item.end_date = item.end_date
        ? moment(item.end_date).format(constants.dateFormat)
        : null;
      item.paidAt = item.paidAt
        ? moment(item.paidAt).format(constants.dateFormat)
        : null;
      item.total_amount = parsePrice(item.total_amount);

      return item;
    };

    const formatPlans = (item) => {
      item.backup_plan = fromatPlan(item.backup_plan);
      item.deduction_plan = fromatPlan(item.deduction_plan);
      item.basic_plan = fromatPlan(item.basic_plan);

      return item;
    };

    const formatNotes = (item) => {
      const namingFormat = (note) =>
        Object.assign(
          {},
          { comment: note.body, createdBy: note.operator },
          note
        );
      const formatDate = (note) => {
        note.createdAt = moment(note.createdAt.value).format(
          constants.dateTimeFormat
        );

        return note;
      };
      item.notes = reverse(
        map(flow([toObject, namingFormat, formatDate]))(item.notes)
      );

      return item;
    };

    const formatStatus = (item) => {
      const findStatus = (listItem) => item.status === listItem.name;
      const statusObj = find(findStatus)(this.Lists.invoiceStatus);
      const findCashCollectionStatus = (listItem) =>
        item.cash_collection_status === listItem.name;
      const cashCollectionStatusObj = find(findCashCollectionStatus)(
        this.Lists.cashCollectionStatus
      );

      item.statusObj = statusObj;
      item.cashCollectionStatus = cashCollectionStatusObj;
      return item;
    };

    return flow([formatDate, formatStatus, formatPlans, formatNotes])(data);
  }

  justifyItem(data) {
    const format = (item) => {
      item.amount = parsePrice(item.amount);
      item.date = moment(item.date).format(constants.dateTimeFormat);
      item.type = item.name;
      item.contractor = item.contractor && item.contractor.name_i18n.en;

      return item;
    };

    return map(format)(data);
  }
}

export default InvoicePageTransform;



// WEBPACK FOOTER //
// ./src/pages/invoice/invoice.transforms.js